import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import StoreShape from '../../../shared/store-proptypes'
import Loader from '../../../shared/components/Loader'

import ItemPreviewItem from './ItemPreviewItem'

@inject('item') @observer
export default
class ItemPreview extends Component {

  static propTypes = {
    item: StoreShape.isRequired,
    slice: PropTypes.array.isRequired,
  };

  render() {

    if (this.props.item.loading) {
      return (
        <Loader>
          Inhalte werden geladen.
        </Loader>
      )
    }

    if (this.props.item.error) {
      return <div>Fehler beim Laden der Inhalte</div>
    }

    const SIZE = 200

    return (
      <div className="row preview-image-list">
        {(this.props.item.collection || [])
          .slice(...this.props.slice)
          .map((item) => (
            <ItemPreviewItem
              key={`${item.id}_${item.imageId}`}
              item={item}
              size={SIZE}
            />
          ))}
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/ItemPreview.js